import { useEffect, useRef } from 'react';

import type { AnyObject } from '../../../../../../types';
import { bridge } from '../../../../../../utils';

type UseLogViewFilterBottomSheetProps = {
  logging: AnyObject | undefined;
};
export const useLogViewFilterBottomSheet = ({
  logging,
}: UseLogViewFilterBottomSheetProps) => {
  const hasLogged = useRef(false);

  useEffect(() => {
    if (!logging || hasLogged.current) {
      return;
    }
    hasLogged.current = true;

    bridge.logAnalyticsEvent({
      name: 'VIEW_FILTER',
      ably_only_log: logging.ably_only_log,
      analytics: {
        ...logging.analytics.analytics,
        SCREEN: 'FILTER',
      },
    });
  }, [logging]);
};
